module.exports = __webpack_public_path__ + "static/media/my-caret.5706c953.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/my-caret.svg
// module id = 962
// module chunks = 57